import { useEffect, useMemo } from 'react';
import { FallbackProps } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { Loader } from '../Loader';
import { EmptyStateWithIllustration } from '../empty-state-with-illustration';
import { GlobalErrorEmptyStateIcon } from '../icons/empty-state/GlobalError';

export const GlobalErrorEmptyState = ({ error }: FallbackProps) => {
  const { t } = useTranslation('layouts/pm');

  // const isLoadingChunkError = useMemo(() => {
  //   const errorMessage =
  //     (error.message as string | undefined)?.toLowerCase() || '';
  //   const wordsToMatch = ['loading chunk', 'loading css chunk'];
  //   return (
  //     wordsToMatch.some((word) => errorMessage.includes(word)) &&
  //     errorMessage.includes('/static')
  //   );
  // }, [error]);

  const isDynamicImportError = useMemo(() => {
    const errorMessage =
      (error.message as string | undefined)?.toLowerCase() || '';
    return (
      errorMessage.includes('failed to fetch dynamically imported module') &&
      errorMessage.includes('/assets')
    );
  }, [error]);

  useEffect(() => {
    console.error('GlobalErrorFallback', error);

    // refresh on lazy module load error
    if (isDynamicImportError) {
      console.log('Reloading page as the asset is stale...');
      window.location.reload();
    }
  }, [error, isDynamicImportError]);

  if (isDynamicImportError) {
    return <Loader />;
  }

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center">
      <EmptyStateWithIllustration
        title={t('global-error-empty-state-title')}
        description={t('global-error-empty-state-description')}
        illustration={
          <div className="relative mb-4 h-52 w-52 rounded-full bg-gray-100">
            <GlobalErrorEmptyStateIcon className="absolute right-0 top-11 w-32" />
          </div>
        }
        primaryButtonText={t('refresh-page')}
        primaryButtonOnClick={() => window.location.reload()}
        secondaryButtonText={t('back-to-home-page')}
        secondaryButtonOnClick={() => (window.location.href = '/')}
      />
    </div>
  );
};
